import React from 'react'
import ListItemContainer from './ListItemContainer'

const ListItem = props => <ListItemContainer {...props} />

export default ListItem
